import { render, staticRenderFns } from "./SelectInputComponent.vue?vue&type=template&id=054da9be&scoped=true&"
import script from "./SelectInputComponent.vue?vue&type=script&lang=js&"
export * from "./SelectInputComponent.vue?vue&type=script&lang=js&"
import style0 from "./SelectInputComponent.vue?vue&type=style&index=0&id=054da9be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054da9be",
  null
  
)

export default component.exports